export class Contact {
         currentEmail: string;
         newEmail: string;
         retypeEmail: string;
         phone: string;
         foreignPhone: string;
         unsuccessMsg: string;
}
